import { memo } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import type { MerchantDomain as MerchantDomainType } from "features/merchants/types";

const MerchantDomain = ({ sourceUrl, expiresAtDate }: MerchantDomainType) => (
    <Box
        sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 1
        }}
    >
        <Typography
            sx={{
                color: 'primary.main',
                fontWeight: 500,
                textDecoration: 'none',
                width: 'fit-content'
            }}
            component='a'
            href={sourceUrl}
        >
            {sourceUrl}
        </Typography>
        <Tooltip
            arrow
            placement='top'
            title='Domain Expiration Date'
        >
            <Typography
                sx={{
                    color: 'info.main',
                    fontWeight: 600,
                    width: 'fit-content'
                }}
            >
                {expiresAtDate}
            </Typography>
        </Tooltip>
    </Box>
);

export default memo(MerchantDomain);
